export class FileInfo {
  data?: string;
  crc?: number;
  id?: number;
  constructor() {}
}

export class CommandP2P {
  serial: string;
  loraid: string;
  p2pTipoComando: number;
  p2pTimeout: string;
  p2pParam: string;
  forcarEnvio: boolean;
  userid: number;
  sistema: string;
  p2pCommandSeq: string;

  constructor() {
    (this.serial = ''), (this.loraid = '');
    (this.p2pTipoComando = 1),
      (this.p2pTimeout = new Date(new Date().setDate(new Date().getDate() + 1))
        .toISOString()
        .slice(0, 16)),
      (this.p2pParam = '1'),
      (this.forcarEnvio = false),
      (this.userid = -1),
      (this.sistema = 'logan'),
      (this.p2pCommandSeq = 'null');
  }
}

export class RemoveCommandP2P {
  serial: string;
  loraid: string;
  userid: number;
  sistema: string;

  constructor() {
    (this.serial = ''), (this.loraid = '');
    (this.userid = -1), (this.sistema = 'logan');
  }
}

export class CommandP2PType {
  id: number;
  nome: string;
  temParametro: boolean;
  exemplo: string;

  constructor() {
    (this.id = -1),
      (this.nome = ''),
      (this.temParametro = false),
      (this.exemplo = '');
  }
}
